import React from 'react';

import { agentsBaseAdminRoute } from '@lumapps/agent-hub-agents/routes';
import { agentHubAskAiAudienceAdminRoute } from '@lumapps/agent-hub-ask-ai-audience/routes';
import { AGENT_HUB_MCPS } from '@lumapps/agent-hub-mcps/keys';
import { mcpsBaseAdminRoute } from '@lumapps/agent-hub-mcps/routes';
import { agentHubServiceSettingsAdminRoute } from '@lumapps/agent-hub-service-settings/routes';
import { agentHubBaseSourcesAdminRoute } from '@lumapps/agent-hub-sources/routes';
import { canAccessAgentHubAdminSelector } from '@lumapps/agent-hub/ducks/selectors';
import { AGENT_HUB } from '@lumapps/agent-hub/keys';
import { getAgentAnalyticsRoute } from '@lumapps/agents-analytics/routes';
import {
    SideNavigationSection as Section,
    SideNavigationItem,
    type SideNavigationSectionProps,
} from '@lumapps/lumx-back-office/components/SideNavigation';
import { robotSparkle } from '@lumapps/lumx/custom-icons';
import { useSelector } from '@lumapps/redux/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';

/**
 * Backoffice side navigation section for the Agent hub
 */
export const AgentHubSideNavigation: React.FC<Partial<SideNavigationSectionProps>> = (props) => {
    const { translateKey } = useTranslate();
    const canAccessAgentHubAdmin = useSelector(canAccessAgentHubAdminSelector);

    if (!canAccessAgentHubAdmin) {
        return null;
    }

    return (
        <Section {...props} header={translateKey(GLOBAL.AGENT_HUB)} id="agent-hub">
            <SideNavigationItem label={translateKey(AGENT_HUB.AGENT_STUDIO)} id="agent-studio" icon={robotSparkle}>
                <SideNavigationItem
                    label={translateKey(GLOBAL.AGENTS)}
                    id="agent-studio-agents"
                    route={agentsBaseAdminRoute}
                    pathMatchForHighlighting={
                        [`${agentsBaseAdminRoute.path}/*`, getAgentAnalyticsRoute(':id').path] as unknown as string
                    }
                />
                <SideNavigationItem
                    label={translateKey(AGENT_HUB.KNOWLEDGE_SOURCES)}
                    id="agent-studio-sources"
                    route={agentHubBaseSourcesAdminRoute}
                />
                <SideNavigationItem
                    label={translateKey(AGENT_HUB_MCPS.MCP)}
                    id="agent-studio-external-mcp"
                    route={mcpsBaseAdminRoute}
                />

                <SideNavigationItem
                    label={translateKey(GLOBAL.SETTINGS)}
                    id="agent-studio-settings"
                    route={agentHubServiceSettingsAdminRoute}
                />
                <SideNavigationItem
                    label={translateKey(AGENT_HUB.ASK_AI_AUDIENCE)}
                    id="agent-studio-ask-ai-management"
                    route={agentHubAskAiAudienceAdminRoute}
                />
            </SideNavigationItem>
        </Section>
    );
};

AgentHubSideNavigation.displayName = 'SideNavigationItem';
